export default __webpack_public_path__ + "static/media/emotional-wellbeing.d3294430.png";